
import CounterSection from "../components/homeComponents/counterSection";
import HeroBanner from "../components/homeComponents/heroBanner";
import HowItWorks from "../components/homeComponents/howItsWork";
import ExpertCarousel from "../components/homeComponents/expertCarousel";
import WhyChooseUs from "../components/homeComponents/whyChooseUs";
import TestimonialSlider from "../components/homeComponents/testimonial";
import MentalHealthServices from "../components/homeComponents/helpYouSection";
import SEO from "../utils/Seo";

const Home = () => {
  const metadata = {
  keywords: `
    book a therapist, online couples therapy, online ocd therapy, 
    online therapy for anxiety, online therapy for depression, 
    best online therapy india, online cbt therapy, 
    family constellation therapy near me, anxiety treatment near me, 
    anxiety treatment in hindi, cbt for social anxiety, 
    counseling near me for depression, online depression counselling, 
    counselling for depression and anxiety, relationship counseling near me, 
    counselling for relationship issues, relationship counselling online, 
    individual therapy, affordable counseling, cbt therapy near me, 
    cbt therapy in hindi, cbt and dbt therapy, ptsd treatment near me, 
    professional counseling, counseling, therapy, self-care, 
    therapy services, online therapy, emotional support, 
    behavioral therapy, holistic therapy, individual counseling, 
    affordable therapy, wellness therapy, virtual counseling, 
    professional counselors, certified counselors, 
    mental health counselors, online counselors, licensed counselors
  `,
  description: `Book certified online therapists for anxiety, depression, relationships, and more. 
  Get affordable, confidential counseling and CBT sessions with top-rated professionals in India. 
  Choose from individual, couples, or family therapy — available in Hindi and English.`
};
    return(<>
    
       <SEO keyword={metadata.keywords

       } description={metadata.description}/>
      <HeroBanner/>
      <CounterSection/>
      <HowItWorks/> 
      <ExpertCarousel />
      <MentalHealthServices/>
      <WhyChooseUs/>
      <TestimonialSlider/>
    </>
    )
}

export default Home;